module.exports = __webpack_public_path__ + "img/Earth.37ad75b8.svg";